import { TagApi } from '@movilizame/networking';

export class PasajerosApi {

    constructor (net, list) {
        this.net = new TagApi(net, list);
    }

    /**
     * Devuelve el estado actual del pasajero
     * @param {string} timestamp
     */
    estado (data = {}) {
        return this.net.tag('check-state').get('/api/pasajero/v2/estado', data);
    }

    /**
     * Devuelve un listado de viajes
     * @param {object} data
     * @param {Date} data.desde
     * @param {Date} data.hasta
     */
    listado (data) {
        return this.net.get('/api/pasajero/listado', data);
    }

    reservas () {
        return this.net.get('/api/pasajero/reservas');
    }

    /**
     * Cambia los datos del perfil
     * @param {object} data
     * @param {Date} data.nombre
     * @param {Date} data.apellido
     * @param {Date} data.telefono
     * @param {Date} data.password
     * @param {Date} data.password_confirmation
     */
    changeProfile (data) {
        return this.net.post('/api/pasajero/usuario', data);
    }

    /**
     * Solicita beneficio de descuento (residente/jubilado).
     * @param {FormData|object} formData - debe incluir tipo_beneficio ('residente'|'jubilado')
     */
    subirDocumentoBeneficio (formData) {
        return this.net.post('/api/pasajero/documento-beneficio', formData);
    }

    /***
     * Crea un nuevo viaje
     *
     * @pre  Ningún viaje en proceso
     * @data
     *  'calle' => 'required|max:50',
     *  'altura' => 'required|integer',
     *  'lat' => 'required',
     *  'lng' => 'required',
     *  'comentario' => 'max:500'
     *
     **/

    createTrip (data) {
        return this.net.post('/api/pasajero/nuevo', data);
    }

    /**
     * Crea una preferencia de Mercado Pago para pago de reserva.
     * @param {object} data - { monto, back_url_success?, back_url_failure? }
     * @returns {Promise<{id, preference_id, init_point}>}
     */
    crearPreferenciaReserva (data) {
        return this.net.post('/api/pasajero/reserva/preferencia', data);
    }

    /***
     * Cancela el viaje actual
     *
     * @pre  Viaje creado y en estado pendiente
     * @data @viaje_id or null (busca el viaje actual)
     *       @comentario [Debería ser obligatorio si el viaje tiene chofer asignado a un viaje]
     *       @lat
     *       @lng
     *
     **/

    cancelTrip (data) {
        console.log('api cancelTrip passenger');
        return this.net.post('/api/pasajero/cancelar', data);
    }

    /***
     * Indicar que te subiste a un viaje
     *
     * @pre  Algun chofer haya aceptado el viaje.
     * @data @viaje_id or null (busca el viaje actual)
     *       @comentario
     *       @lat
     *       @lng
     *
     **/

    rideupTrip (data) {
        return this.net.post('/api/pasajero/abordar', data);
    }

    /***
     * Indicar que se termino el viaje
     *
     * @pre  Estar subido a un viaje
     * @data @viaje_id or null (busca el viaje actual)
     *       @comentario
     *       @lat
     *       @lng
     *
     **/

    endTrip (data) {
        return this.net.post('/api/pasajero/finalizar', data);
    }

    /***
     * Calificar un viaje
     *
     * @pre  Terminar un viaje recientemente y no haberlo calificado
     * @data @viaje_id
     *       @calificacion (1 al 5)
     *
     **/

    rateTrip (data) {
        return this.net.post('/api/pasajero/calificar', data);
    }

    /***
     * Marca como visto el viaje cancelado
     *
     * @pre  Tener un viaje recien cancelado
     * @data
     *
     **/

    markCancelTrip () {
        return this.net.post('/api/pasajero/viaje-cancelado-visto');
    }

    /**
     *  Indica la posicion al  servidor
     */
    location (data) {
        return this.net.post('/api/pasajero/coordenadas', data);
    }

    /**
     *  compartir el viaje con otro usuario
     * @param {string} data.email
     */
    shareTrip (data) {
        return this.net.post('/api/pasajero/compartir', data);
    }

    /**
     * Viajes compartidos
     */
    sharedTripList () {
        return this.net.post('/api/pasajero/ver-viajes');
    }

    /**
     * Upgrade pasajero to chofer
     *
     * @param {object} data
     */

    upgradeChofer (data) {
        return this.net.post('/api/pasajero/upgradeChofer', data);
    }

    getBeneficiosCatalogo (data) {
        return this.net.get('/api/pasajero/beneficios/catalogo', data);
    }

    crearTarjetaBeneficio (data) {
        return this.net.post('/api/pasajero/beneficios/tarjetas', data);
    }

    getMisTarjetasBeneficio (data) {
        return this.net.get('/api/pasajero/beneficios/tarjetas', data);
    }

    canjearTarjetaBeneficio (data) {
        return this.net.post('/api/pasajero/beneficios/canjear', data);
    }
}



// WEBPACK FOOTER //
// ./src/services/api/PasajerosApi.js